import { RechargeType, QuizAnswers } from '@vacationtracker/shared/types/recharge-type'

export function calculateRechargeType(answers: QuizAnswers): RechargeType {
  const { q1, q2 } = answers

  if (q1 === true && q2 === false) {
    return RechargeType.SOCIAL_SPRINTER
  }
  if (q1 === true && q2 === true) {
    return RechargeType.STRUCTURED_SOCIALIZER
  }
  if (q1 === false && q2 === false) {
    return RechargeType.SPONTANEOUS_SOLOIST
  }
  if (q1 === false && q2 === true) {
    return RechargeType.DEEP_RESTORER
  }

  // Fallback (shouldn't happen)
  return RechargeType.SOCIAL_SPRINTER
}

export function shouldShowQ3(answers: QuizAnswers): boolean {
  const { q1, q2 } = answers
  // Show Q3 only if Q1 and Q2 are "same direction" (both A or both B)
  // Q1: A=true (social), B=false (alone)
  // Q2: A=false (spontaneous/unstructured), B=true (structured)
  // "Both A" = q1=true, q2=false → Social Sprinter path
  // "Both B" = q1=false, q2=true → Deep Restorer path
  // So Q3 shows when q1 !== q2 (opposite boolean values = same letter choice)
  return q1 !== q2
}
